<template>
  <div class="department-container">
    <div class="search-bar">
      <input type="text" placeholder="ID" v-model="searchId" />
      <input type="text" placeholder="部门名称" v-model="searchDepartmentName" />
      <button class="search-button" @click="search">搜索</button>
      <button class="clear-button" @click="clear">清空</button>
    </div>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>部门</th>
          <th>早餐规则</th>
          <th>午餐规则</th>
          <th>晚餐规则</th>
          <th>添加时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="department in filteredDepartments" :key="department.id">
          <td>{{ department.id }}</td>
          <td>{{ department.bumen }}</td>
          <td>{{ getRuleName(department.zaocanRule) }}</td>
          <td>{{ getRuleName(department.wucanRule) }}</td>
          <td>{{ getRuleName(department.wancanRule) }}</td>
          <td>{{ department.time }}</td>
          <td>
            <button class="delete-button" @click="deleteDepartment(department.id)">删除</button>
          </td>
        </tr>
      </tbody>
      
    </table>
    <div class="add-button">
      <button @click="showDrawer = true">添加</button>
    </div>
    <div class="drawer" v-if="showDrawer">
      <div class="drawer-header">
        <h3>添加部门规则</h3>
        <button @click="showDrawer = false">关闭</button>
      </div>
      <div class="drawer-body">
        <form @submit.prevent="addDepartment">
          <div class="form-group">
            <label for="departmentName">部门名称</label>
            <select id="departmentName" v-model="newDepartment.name" required>
              <option value="">选择-</option>
              <option v-for="dept in uniqueDepartments" :key="dept" :value="dept">{{ dept }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="breakfastRule">关联早餐规则</label>
            <select id="breakfastRule" v-model="newDepartment.breakfastRule">
              <option value="">选择-</option>
              <option v-for="rule in rules" :key="rule.id" :value="rule.id">{{ rule.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="lunchRule">关联午餐规则</label>
            <select id="lunchRule" v-model="newDepartment.lunchRule">
              <option value="">选择-</option>
              <option v-for="rule in rules" :key="rule.id" :value="rule.id">{{ rule.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="dinnerRule">关联晚餐规则</label>
            <select id="dinnerRule" v-model="newDepartment.dinnerRule">
              <option value="">选择-</option>
              <option v-for="rule in rules" :key="rule.id" :value="rule.id">{{ rule.name }}</option>
            </select>
          </div>
          <button type="submit">添加</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      showDrawer: false,
      newDepartment: {
        name: '',
        breakfastRule: '',
        lunchRule: '',
        dinnerRule: '',
        ruleDescription: ''
      },
      departments: [],
      rules: [],
      uniqueDepartments: [],
      searchId: '',
      searchDepartmentName: ''
    };
  },
  computed: {
    filteredDepartments() {
      return this.departments.filter(department => {
        const matchesId = this.searchId ? department.id.toString().includes(this.searchId) : true;
        const matchesName = this.searchDepartmentName ? department.bumen.includes(this.searchDepartmentName) : true;
        return matchesId && matchesName;
      });
    }
  },
  methods: {
    async fetchDepartments() {
      try {
        const response = await this.$axios.get('/api/show_bumen_guize');
        const data = response.data;
        if (data.code === 0) {
          this.departments = data.data;
        } else {
          console.error('Failed to fetch departments:', data.message);
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    },
    async fetchRules() {
      try {
        const response = await this.$axios.get('/api/show_guize');
        const data = response.data;
        if (data.code === 0) {
          this.rules = data.data;
        } else {
          console.error('Failed to fetch rules:', data.message);
        }
      } catch (error) {
        console.error('Error fetching rules:', error);
      }
    },
    async fetchUniqueDepartments() {
      try {
        const response = await this.$axios.get('/api/show_tongxunlu');
        const data = response.data;
        if (data.code === 0) {
          const deptNames = data.data.map(item => item.department);
          this.uniqueDepartments = [...new Set(deptNames)]; // Remove duplicates
        } else {
          console.error('Failed to fetch unique departments:', data.message);
        }
      } catch (error) {
        console.error('Error fetching unique departments:', error);
      }
    },
    getRuleName(ruleId) {
      const iid = Number(ruleId);
      const rule = this.rules.find(r => r.id === iid);
      return rule ? rule.name : '未知规则';
    },
    async addDepartment() {
      const departmentData = {
        bumen: this.newDepartment.name,
        zaocanRule: this.newDepartment.breakfastRule,
        wucanRule: this.newDepartment.lunchRule,
        wancanRule: this.newDepartment.dinnerRule
      };

      try {
        const response = await this.$axios.post('/api/add_bumen_guize', departmentData);
        const data = response.data;
        if (data.code === 0) {
          this.$message.success({
            message: '部门规则添加成功',
            duration: 2000
          });
          this.showDrawer = false;
          this.fetchDepartments(); // 刷新部门列表
        } else {
          this.$message.error({
            message: '部门规则添加失败',
            duration: 2000
          });
        }
      } catch (error) {
        console.error('Error adding department:', error);
      }
    },
    async deleteDepartment(id) {
      if (confirm('确定要删除这个部门规则吗？')) {
        try {
          const response = await this.$axios.post('/api/delete_bumen_guize', { id });
          const data = response.data;
          if (data.code === 0) {
            this.$message.success({
            message: '部门规则删除成功',
            duration: 2000
          });
            this.fetchDepartments(); // 刷新部门列表
          } else {
            this.$message.error({
            message: '部门规则删除失败',
            duration: 2000
          });
          }
        } catch (error) {
          console.error('Error deleting department:', error);
        }
      }
    },
    search() {
      // 搜索逻辑已经在 computed 属性中实现
    },
    clear() {
      this.searchId = '';
      this.searchDepartmentName = '';
    }
  },
  mounted() {
    this.fetchDepartments();
    this.fetchRules();
    this.fetchUniqueDepartments();
  }
};
</script>

<style scoped>
.department-container {
  padding: 20px;
}

.search-bar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-bar input,
.search-bar button {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-button {
  background-color: #007bff;
  color: white;
}

.clear-button {
  background-color: #dc3545;
  color: white;
}

.add-button {
  text-align: right;
  margin-top: 20px;
}

.add-button button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 20px;
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.drawer-body {
  border-top: 1px solid #ccc;
  padding-top: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button[type="submit"] {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>